import ApiRequest from '../request'

export default class ExtAgs {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async getAnnexes(code) {
    try {
      const res = await this.apiRequest.get(`ext_ags2d/${code}`)
      return res
    } catch (error) {
      return error.response
    }
  }
}
